import { Outlet } from 'react-router-dom'
import { ContainerEventosCheckin } from './components/container'
import { ProviderServicesEventosCheckin } from './context/getServicesEventos'

export type Evento = {
  id: number,
  descricao: string,
  atividade: number,
  inicio: string,
  fim: string,
  nome_cidade: string,
  nome_sede: string,
  sede: number,
  cidade: number,
  inscricao: boolean,
  ativo: boolean,
  whatsapp: string,
  celula: number | string,
  cep: string
}

export default function EventosCheckin() {

  return (
    <>
      <ProviderServicesEventosCheckin>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerEventosCheckin />
        </div>
        <Outlet/>
      </ProviderServicesEventosCheckin>
    </>
  )

}
